import { render, staticRenderFns } from "./PopUpText.vue?vue&type=template&id=41787d1f&"
import script from "./PopUpText.vue?vue&type=script&lang=js&"
export * from "./PopUpText.vue?vue&type=script&lang=js&"
import style0 from "./PopUpText.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports